import { useMemo } from 'react';

import { RecentCallsTracker } from './RecentCallsTracker';
import {
  CallId,
  CallLogItem,
  Section,
  SectionTitle,
  TerminationCode,
} from './styles';

import { TerminationType } from 'features/call/call-base/enums';

export const CallHistoryTab = () => {
  const callLog = useMemo(() => {
    return RecentCallsTracker.getInstance().getCallLog();
  }, []);

  return (
    <Section>
      <SectionTitle variant='subtitle2'>Recent Calls</SectionTitle>
      {callLog
        ?.slice()
        .reverse()
        .map((call, idx: number) => (
          <CallLogItem key={call.callId}>
            <CallId variant='body2'>
              #{idx + 1}: {call.callId}
            </CallId>
            <TerminationCode variant='body2'>
              {TerminationType[call.terminationCode]}
            </TerminationCode>
          </CallLogItem>
        ))}
    </Section>
  );
};
